import React, { FC, Fragment } from 'react';
import styles from './buttons-bar.module.css';

const ButtonsBar: FC<ButtonsBarProps> = ({
  containerStyle,
  children,
  pattern,
  sideAlign,
  verticalAlign,
}) => {
  let sideClass;
  switch (sideAlign) {
    case 'left':
      sideClass = styles.alignLeft;
      break;
    case 'center':
      sideClass = styles.alignCenter;
      break;
    case 'right':
      sideClass = styles.alignRight;
      break;
    default:
      sideClass = styles.alignRight;
  }

  const togetherClass = `${styles.buttonsContainer} ${sideClass}`;

  const renderButtons = () => {
    if (pattern === 'firstSeparate') {
      if (Array.isArray(children)) {
        return (
          <Fragment>
            <div className={styles.buttonsContainer}>
              {children[0] && children[0]}
            </div>
            <div className={styles.buttonsContainer}>
              {children.map((item, idx) => {
                if (idx > 0) return item;
                return null;
              })}
            </div>
          </Fragment>
        );
      }
    } else if (pattern === 'together') {
      if (Array.isArray(children)) {
        return (
          <div className={togetherClass}>{children.map((item) => item)}</div>
        );
      } else {
        return <div className={togetherClass}>{children}</div>;
      }
    } else {
      return <div className={togetherClass}>{children}</div>;
    }
  };

  let verticalClass;
  switch (verticalAlign) {
    case 'top':
      verticalClass = styles.verticalTop;
      break;
    case 'center':
      verticalClass = styles.verticalCenter;
      break;
    case 'bottom':
      verticalClass = styles.verticalBottom;
      break;
    default:
      verticalClass = styles.verticalCenter;
  }

  if (!children) return null;

  return (
    <div
      className={`${styles.buttonsGeneralContainer} ${verticalClass}`}
      style={containerStyle}
    >
      {renderButtons()}
    </div>
  );
};

export default ButtonsBar;
